var _effectorFileName = "/builds/gmini/front-ui-kit/src/MacosExplorer/propsCtx.ts";
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ExplorerPropsCtx = /*#__PURE__*/React.createContext( // eslint-disable-next-line @typescript-eslint/no-explicit-any
null); // TODO generic type

export const useExplorerProps = () => {
  const props = React.useContext(ExplorerPropsCtx);
  return props;
};